import {
  generateBindings,
  observableValue,
  useEffect,
  useRef,
  useSharedState,
  view,
  WritableObservableValue,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-radio';
import { Radio as MdcRadio } from '@material/mwc-radio';
import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { ref } from 'lit/directives/ref.js';

export const [Radio] = view('esui-mwc-radio', {
  Props: class {
    checked = observableValue(false);
    group: WritableObservableValue<boolean>[] = [];
    disabled = false;
    name = '';
    value = '';
    global = false;
    id?: string = undefined;
    reducedTouchTarget = false;
  },

  mapBuilder:
    RadioBuilder =>
    (
      checked: WritableObservableValue<boolean>,
      group: WritableObservableValue<boolean>[] = []
    ) =>
      RadioBuilder().checked(checked).group(group),

  template(props) {
    const checked = useSharedState(props.checked);
    const inputRef = useRef<MdcRadio>();

    const computedProps = generateBindings(props, ['id', 'checked', 'group']);

    function handleChange(e: { target: HTMLInputElement }) {
      checked.value = e.target.checked;
      props.group
        .filter(obs => obs !== checked)
        .forEach(obs => {
          obs.value = !e.target.checked;
        });
    }

    useEffect(
      element => {
        element.focus = () => {
          inputRef.value?.focus();
        };

        element.click = () => {
          inputRef.value?.click();
        };
      },
      [inputRef.value]
    );

    return html`
      <mwc-radio
        ${ref(inputRef)}
        id="${ifDefined(props.id)}"
        ${spread({ ...computedProps })}
        ?checked="${checked.value}"
        @change="${handleChange}"
      >
      </mwc-radio>
    `;
  },
  noShadow: true,
});
